export enum ItemRenderTypes {
  JUMP_NEXT = 'jump-next',
  JUMP_PREV = 'jump-prev',
  PAGE = 'page',
  PREV = 'prev',
  NEXT = 'next',
}

export enum SearchProps {
  PLACEHOLDER_STRING = 'Search',
  SEARCH_NAME = 'search',
  EMPTY_STRING = '',
}

export enum ButtonProps {
  CREATE_BRAND = 'Create Brand',
  CREATE_PRODUCT = 'Create Product',
  NEW_PRODUCT = 'New Product',
  ADD_ANOTHER_YEAR = 'Add Another Year',
  Validation_Text = 'Child products cannot be created for older products',
  IS_NEW_TEXT_ERROR = 'Child products can be created only for approved products',
}
export enum BrandPageProps {
  PAGE_TITLE = 'Products',
}

export enum TabsProps {
  DEFAULT_ACTIVE_KEY = '0',
}
export enum TabsKeys {
  ALL_PRODUCTS = 'products',
  IN_REVIEW = 'in-review',
  APPROVED = 'approved',
  DRAFT = 'draft',
  DECLINED = 'declined',
  BRANDS = 'brands',
}
export enum TabsLabels {
  ALL_PRODUCTS = 'All Products',
  IN_REVIEW = 'In review',
  APPROVED = 'Approved',
  DRAFT = 'Draft',
  DECLINED = 'Declined',
  BRANDS = 'Brands',
  IN_REVIEW_STATUS = 'in review',
}

export enum TabsIndex {
  ALL_PRODUCTS = 'products',
  IN_REVIEW = 'in-review',
  APPROVED = 'approved',
  DRAFT = 'draft',
  DECLINED = 'declined',
  BRANDS = 'brands',
}

export enum customPaginationProps {
  ITEM_RENDER = 'itemRender',
}

export enum ProductsViewProps {
  ELIPSIS = '...',
  BACK_ARROW = '&lt;&lt;',
  FORWARD_ARROW = '&gt;',
  PREVIOUS = '&lt;',
}
